exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-table .cell{word-break:normal!important}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Fields/FieldTable.vue"],"names":[],"mappings":"AACA,gBACE,2BAA8B,CAC/B","file":"FieldTable.vue","sourcesContent":["\n.el-table .cell {\n  word-break: normal !important;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d26d5750","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Fields/FieldTable.vue
// module id = 1010
// module chunks = 9